import axios from "axios";

import { CarrierOption } from "../components/PickupRequestForm";

interface PickupRequestCarrierResponse {
  id: number;
  firstName: string;
  lastName: string;
}

export const getPickupRequestCarriers = (
  haulerCompanyId: number
): Promise<CarrierOption[]> =>
  axios
    .get<PickupRequestCarrierResponse[]>("/pickupRequests/carriers", {
      params: { haulerCompanyId },
    })
    .then(({ data }) =>
      data.map((carrier) => ({
        id: carrier.id,
        name: `${carrier.firstName} ${carrier.lastName}`,
      }))
    );
